import React, { useContext, useEffect } from "react";
import { ContentProps } from "./types";

import { LabelModule } from "../Modules/LabelModule.tsx";
import { TextInputModule } from "../Modules/TextInputModule.tsx";
import { EmailInputModule } from "../Modules/EmailInputModule.tsx";
import { NumberInputModule } from "../Modules/NumberInputModule.tsx";
import { TextAreaModule } from "../Modules/TextAreaModule.tsx";
import { DateInputModule } from "../Modules/DateInputModule.tsx";
import { SingleChoiceModal1 } from "../Modules/SingleChoiceModal1.tsx";
import { SingleChoiceModal3 } from "../Modules/SingleChoiceModal3.tsx";
import { MultiChoiceModal1 } from "../Modules/MultiChoiceModal1.tsx";
import { MultiChoiceModal2 } from "../Modules/MultiChoiceModal2.tsx";
import { PrimaryButton } from "../../../../components/Modules/PrimaryButton.tsx";
import { SecondaryButton } from "../../../../components/Modules/SecondaryButton.tsx";
import { useOnboarding } from "./OnboardingContext";
import General, { useGeneral } from "../../../../general.ts";
import { leftArrow, rightArrow } from "../../../../assets/assetsSVG.tsx";
import QuestContext from "../../../../components/QuestWrapper.tsx";

const Content: React.FC<ContentProps> = () => {
  const {
    design,
    // designState,
    formdata,
    progress,
    progressBarMultiLine,
    template,
    controlBtnType,
    uiProps,
    nextBtnText,
    // btnFlag,
    returnAnswers,
    answer,
    checkValidationValues,
    // handleUpdate,
    validateInputRegex,
    themeManager,
    // validationData,
    currentPage = 0,
    setCurrentPage,
    handleUpdate,
    ProgressBar,
    questionTemplate,
    btnFlag,
    designState,
    onboardingGetPropsFunctions,
    userId,
    uniqueUserId
  } = useOnboarding();

  const { apiType, user } = useContext(QuestContext.Context);
  let GeneralFunctions = new General("mixpanel", apiType);
  const general = useGeneral('quest')


  useEffect(() => {
    if (designState && currentPage >= designState.length && designState.length > 0) {
    setCurrentPage &&  setCurrentPage(designState.length - 1);
    }
  }, [designState, currentPage, setCurrentPage]);

  // Add safety check for rendering
  const getCurrentPageItems = () => {
    if (!designState || !Array.isArray(designState) || designState.length === 0) {
      return [];
    }

    // Ensure currentPage is within bounds
    const safePage = Math.min(currentPage, designState.length - 1);
    return designState[safePage] || [];
  };
  
  return (
    <>
      <div className="q-onb-main-first">
        {questionTemplate === "multi-question" &&
          formdata.length > 0 &&
          designState.length > 1 &&
          !!progress?.length && <ProgressBar />}

        {!!designState && designState.length > 0
          ? designState[currentPage].map((num: number, index: number) =>
              formdata[num - 1]?.type == "USER_INPUT_TEXT" ? (
                <div className="label-input-cont" key={index}>
                  <LabelModule
                    htmlFor=""
                    // style={{
                    //     color:
                    //         styleConfig?.Label?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Label,
                    // }}
                    style={themeManager.getLabelStyles()}
                  >
                    {`${formdata[num - 1]?.question || ""} ${
                      !!formdata[num - 1]?.required ? "*" : ""
                    }`}
                  </LabelModule>
                  {/* Remove type */}
                  <TextInputModule
                    placeholder={
                      formdata[num - 1]?.placeholder ||
                      formdata[num - 1]?.question ||
                      ""
                    }
                    value={answer[formdata[num - 1].actionId || ""]}
                    validateInputRegex={(validation) =>
                      validateInputRegex(validation, formdata[num - 1].actionId)
                    }
                    // errorText={
                    //     styleConfig?.TextError?.text == undefined
                    //         ? "Invalid text format"
                    //         : styleConfig?.TextError?.text
                    // }
                    errorText={themeManager.getTextInputErrorText()}
                    // textErrorStyle={styleConfig?.TextError?.errorStyle}
                    textErrorStyle={themeManager.getTextInputErrorStyles()}
                    regexKey={formdata[num - 1]?.regexKey}
                    regexMessage={formdata[num - 1]?.regexMessage}
                    onChange={(e) =>
                      handleUpdate(e, formdata[num - 1].actionId || "", "")
                    }
                    // style={{
                    //     borderColor:
                    //         styleConfig?.Input?.borderColor || themeConfig?.borderColor,
                    //     color:
                    //         styleConfig?.Input?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Input,
                    // }}

                    style={themeManager.getTextInputStyles()}
                    // name={`input-${designState?.[currentPage]?.[index]}`}
                    name={`input-${designState?.[currentPage]?.[index]}`}
                    key={formdata[num - 1].actionId}
                  />
                </div>
              ) : formdata[num - 1]?.type == "USER_INPUT_EMAIL" ? (
                <div className="label-input-cont" key={index}>
                  <LabelModule
                    htmlFor=""
                    // style={{
                    //     color:
                    //         styleConfig?.Label?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Label,
                    // }}
                    style={themeManager.getLabelStyles()}
                  >
                    {`${formdata[num - 1]?.question || ""} ${
                      !!formdata[num - 1]?.required ? "*" : ""
                    }`}
                  </LabelModule>

                  <EmailInputModule
                    placeholder={
                      formdata[num - 1]?.placeholder ||
                      formdata[num - 1]?.question ||
                      ""
                    }
                    value={answer[formdata[num - 1].actionId || ""]}
                    // iconColor={
                    //     styleConfig?.Input?.color ||
                    //     BrandTheme?.primaryColor ||
                    //     themeConfig?.primaryColor ||
                    //     "#B9B9B9"
                    // }
                    iconColor={themeManager.getEmailIconColor()}
                    validateInputRegex={(validation) =>
                      validateInputRegex(validation, formdata[num - 1].actionId)
                    }
                    regexKey={formdata[num - 1]?.regexKey}
                    regexMessage={formdata[num - 1]?.regexMessage}
                    onChange={(e) =>
                      handleUpdate(e, formdata[num - 1].actionId || "", "")
                    }
                    style={themeManager.getTextInputStyles()}
                    // style={{
                    //     borderColor:
                    //         styleConfig?.Input?.borderColor || themeConfig?.borderColor,
                    //     color:
                    //         styleConfig?.Input?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Input,
                    // }}
                    emailtext={themeManager.getEmailInputErrorText()}
                    // emailtext={
                    //     styleConfig?.EmailError?.text == undefined
                    //         ? "Invalid email format"
                    //         : styleConfig?.EmailError?.text
                    // }
                    emailErrorStyle={themeManager.getEMailInputErrorStyles()}
                    // emailErrorStyle={styleConfig?.EmailError?.errorStyle}
                    name={`input-${designState?.[currentPage]?.[index]}`}
                    key={formdata[num - 1].actionId}
                  />
                </div>
              ) : formdata[num - 1]?.type == "USER_INPUT_PHONE" ||
                formdata[num - 1]?.type == "USER_INPUT_NUMBER" ? (
                <div className="label-input-cont" key={index}>
                  <LabelModule
                    htmlFor=""
                    // style={{
                    //     color:
                    //         styleConfig?.Label?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Label,
                    // }}
                    style={themeManager.getLabelStyles()}
                  >
                    {`${formdata[num - 1]?.question || ""} ${
                      !!formdata[num - 1]?.required ? "*" : ""
                    }`}
                  </LabelModule>

                  <NumberInputModule
                    placeholder={
                      formdata[num - 1]?.placeholder ||
                      formdata[num - 1]?.question ||
                      ""
                    }
                    value={answer[formdata[num - 1].actionId || ""]}
                    // iconColor={
                    //     styleConfig?.Input?.color ||
                    //     BrandTheme?.primaryColor ||
                    //     themeConfig?.primaryColor ||
                    //     "#B9B9B9"
                    // }

                    iconColor={themeManager.getEmailIconColor()}
                    validateInputRegex={(validation) =>
                      validateInputRegex(validation, formdata[num - 1].actionId)
                    }
                    // numbertext={
                    //     styleConfig?.NumberError?.text == undefined
                    //         ? "Invalid number format"
                    //         : styleConfig?.NumberError?.text
                    // }
                    numbertext={themeManager.getNumberInputErrorText()}
                    // numberErrorStyle={styleConfig?.NumberError?.errorStyle}
                    numberErrorStyle={themeManager.getNumberInputErrorStyles()}
                    regexKey={formdata[num - 1]?.regexKey}
                    regexMessage={formdata[num - 1]?.regexMessage}
                    onChange={(e) =>
                      handleUpdate(e, formdata[num - 1].actionId || "", "")
                    }
                    // style={{
                    //     borderColor:
                    //         styleConfig?.Input?.borderColor || themeConfig?.borderColor,
                    //     color:
                    //         styleConfig?.Input?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Input,
                    // }}
                    style={themeManager.getTextInputStyles()}
                    name={`input-${designState?.[currentPage]?.[index]}`}
                    key={formdata[num - 1]?.actionId}
                  />
                </div>
              ) : formdata[num - 1]?.type == "USER_INPUT_TEXTAREA" ? (
                <div className="label-input-cont" key={index}>
                  <LabelModule
                    htmlFor=""
                    // style={{
                    //     color:
                    //         styleConfig?.Label?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Label,
                    // }}

                    style={themeManager.getLabelStyles()}
                  >
                    {`${formdata[num - 1]?.question || ""} ${
                      formdata[num - 1]?.required || "" ? "*" : ""
                    }`}
                  </LabelModule>
                  <TextAreaModule
                    value={answer[formdata[num - 1].actionId || ""]}
                    onChange={(e) =>
                      handleUpdate(e, formdata[num - 1].actionId || "", "")
                    }
                    // style={{
                    //     borderColor:
                    //         styleConfig?.TextArea?.borderColor || themeConfig?.borderColor,
                    //     color:
                    //         styleConfig?.TextArea?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.TextArea,
                    // }}
                    style={themeManager.getTextAreaInputStyles()}
                    validateInputRegex={(validation) =>
                      validateInputRegex(validation, formdata[num - 1].actionId)
                    }
                    // textareatext={
                    //     styleConfig?.TextAreaError?.text == undefined
                    //         ? "Invalid Textarea format"
                    //         : styleConfig?.TextAreaError?.text
                    // }
                    textareatext={themeManager.getTextAreaInputErrorText()}
                    // textareaErrorStyle={styleConfig?.TextAreaError?.errorStyle}
                    textareaErrorStyle={themeManager.getTextAreaInputErrorStyles()}
                    placeholder={
                      formdata[num - 1]?.placeholder ||
                      formdata[num - 1]?.question ||
                      ""
                    }
                    key={formdata[num - 1]?.actionId}
                  />
                </div>
              ) : formdata[num - 1]?.type == "USER_INPUT_DATE" ? (
                <div className="label-input-cont" key={index}>
                  <LabelModule
                    htmlFor=""
                    // style={{
                    //     color:
                    //         styleConfig?.Label?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Label,
                    // }}

                    style={themeManager.getLabelStyles()}
                  >
                    {`${formdata[num - 1]?.question || ""} ${
                      !!formdata[num - 1]?.required ? "*" : ""
                    }`}
                  </LabelModule>
                  <DateInputModule
                    placeholder={
                      formdata[num - 1]?.placeholder ||
                      formdata[num - 1]?.question ||
                      ""
                    }
                    value={answer[formdata[num - 1].actionId || ""]}
                    onChange={(e) =>
                      handleUpdate(e, formdata[num - 1].actionId || "", "")
                    }
                    // iconColor={
                    //     styleConfig?.Input?.color ||
                    //     BrandTheme?.primaryColor ||
                    //     themeConfig?.primaryColor ||
                    //     "#B9B9B9"
                    // }

                    iconColor={themeManager.getEmailIconColor()}
                    // style={{
                    //     borderColor:
                    //         styleConfig?.Input?.borderColor || themeConfig?.borderColor,
                    //     color:
                    //         styleConfig?.Input?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Input,
                    // }}

                    style={themeManager.getTextInputStyles()}
                    key={formdata[num - 1].actionId}
                    preventFutureSelection={false}
                    preventPastSelection={false}
                    minDate=""
                    maxDate=""
                  />
                </div>
              ) : formdata[num - 1]?.type == "USER_INPUT_SINGLE_CHOICE" ? (
                !!onboardingGetPropsFunctions.getSingleChoose() &&
                (onboardingGetPropsFunctions.getSingleChoose() === "modal1" ||
                  onboardingGetPropsFunctions.getSingleChoose() ===
                    "modal2") ? (
                  // for modal 1 or 2
                  <div className="label-input-cont" key={index}>
                    <LabelModule
                      htmlFor=""
                      // style={{
                      //     color:
                      //         styleConfig?.Label?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.Label,
                      // }}
                      style={themeManager.getLabelStyles()}
                    >
                      {`${formdata[num - 1]?.question || ""} ${
                        !!formdata[num - 1]?.required ? "*" : ""
                      }`}
                    </LabelModule>
                    <SingleChoiceModal1
                      options={formdata[num - 1].options || []}
                      type={onboardingGetPropsFunctions.getSingleChoose()}
                      onChange={(e) =>
                        handleUpdate(
                          e,
                          formdata[num - 1].actionId || "",
                          "radio"
                        )
                      }
                      checked={answer[formdata[num - 1].actionId || ""]}
                      // style={{
                      //     borderColor:
                      //         styleConfig?.SingleChoice?.style?.borderColor ||
                      //         themeConfig?.borderColor,
                      //     color:
                      //         styleConfig?.SingleChoice?.style?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.secondaryColor,
                      //     ...styleConfig?.SingleChoice?.style,
                      // }}

                      style={themeManager.getSingleChoiceStyles()}
                      // hoverBackground={styleConfig?.SingleChoice?.hoverBackground}
                      hoverBackground={themeManager.getSingleChoiceHoverBackground()}
                      // selectedStyle={{
                      //     accentColor:
                      //         styleConfig?.SingleChoice?.selectedStyle?.accentColor ||
                      //         questThemeData?.accentColor ||
                      //         BrandTheme?.accentColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.SingleChoice?.selectedStyle,
                      // }}
                      selectedStyle={themeManager.getSingleChoiceSelectedStyles()}
                      key={formdata[num - 1]?.actionId}
                    />
                    {formdata[num - 1]?.manualInput != false &&
                      answer[formdata[num - 1].actionId || ""] ==
                        formdata[num - 1]?.manualInput && (
                        <TextInputModule
                          type={"text"}
                          onChange={(e) =>
                            handleUpdate(
                              e,
                              formdata[num - 1].actionId || "" + "/manual",
                              ""
                            )
                          }
                          value={
                            answer[formdata[num - 1].actionId || "" + "/manual"]
                          }
                          placeholder="Please fill manually"
                          // style={{
                          //     borderColor:
                          //         styleConfig?.Input?.borderColor || themeConfig?.borderColor,
                          //     color:
                          //         styleConfig?.Input?.color ||
                          //         BrandTheme?.primaryColor ||
                          //         themeConfig?.primaryColor,
                          //     ...styleConfig?.Input,
                          // }}
                          style={themeManager.getTextInputStyles()}
                          key={formdata[num - 1]?.actionId}
                        />
                      )}
                  </div>
                ) : (
                  // for modal 3
                  <div className="label-input-cont" key={index}>
                    <LabelModule
                      htmlFor=""
                      // style={{
                      //     color:
                      //         styleConfig?.Label?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.Label,
                      // }}
                      style={themeManager.getLabelStyles()}
                    >
                      {`${formdata[num - 1]?.question || ""} ${
                        !!formdata[num - 1]?.required ? "*" : ""
                      }`}
                    </LabelModule>
                    <SingleChoiceModal3
                      options={formdata[num - 1].options || []}
                      type={onboardingGetPropsFunctions.getSingleChoose()}
                      onChange={(e) =>
                        handleUpdate(
                          { target: e },
                          formdata[num - 1].actionId || "",
                          ""
                        )
                      }
                      checked={answer[formdata[num - 1].actionId || ""]}
                      // style={{
                      //     borderColor:
                      //         styleConfig?.SingleChoice?.style?.borderColor ||
                      //         themeConfig?.borderColor,
                      //     color:
                      //         styleConfig?.SingleChoice?.style?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.secondaryColor,
                      //     ...styleConfig?.SingleChoice?.style,
                      // }}

                      style={themeManager.getSingleChoiceStyles()}
                      // hoverBackground={styleConfig?.SingleChoice?.hoverBackground}
                      hoverBackground={themeManager.getSingleChoiceHoverBackground()}
                      // selectedStyle={{
                      //     accentColor:
                      //         styleConfig?.SingleChoice?.selectedStyle?.accentColor ||
                      //         questThemeData?.accentColor ||
                      //         BrandTheme?.accentColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.SingleChoice?.selectedStyle,
                      // }}

                      selectedStyle={themeManager.getSingleChoiceSelectedStyles()}
                      key={formdata[num - 1]?.actionId}
                    />
                    {formdata[num - 1]?.manualInput != false &&
                      answer[formdata[num - 1].actionId || ""] ==
                        formdata[num - 1]?.manualInput && (
                        <TextInputModule
                          type={"text"}
                          onChange={(e) =>
                            handleUpdate(
                              e,
                              formdata[num - 1].actionId || "" + "/manual",
                              ""
                            )
                          }
                          value={
                            answer[formdata[num - 1].actionId || "" + "/manual"]
                          }
                          placeholder="Please fill manually"
                          // style={{
                          //     borderColor:
                          //         styleConfig?.Input?.borderColor || themeConfig?.borderColor,
                          //     color:
                          //         styleConfig?.Input?.color ||
                          //         BrandTheme?.primaryColor ||
                          //         themeConfig?.primaryColor,
                          //     ...styleConfig?.Input,
                          // }}

                          style={themeManager.getTextInputStyles()}
                        />
                      )}
                  </div>
                )
              ) : formdata[num - 1]?.type == "USER_INPUT_MULTI_CHOICE" ? (
                !!onboardingGetPropsFunctions.getMultiChoice() &&
               (onboardingGetPropsFunctions.getMultiChoice() == "modal2") ? (
                  <div className="label-input-cont" key={index}>
                    <LabelModule
                      htmlFor=""
                      // style={{
                      //     color:
                      //         styleConfig?.Label?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.Label,
                      // }}
                      style={themeManager.getLabelStyles()}
                    >
                      {`${formdata[num - 1]?.question || ""} ${
                        !!formdata[num - 1]?.required || false ? "*" : ""
                      }`}
                    </LabelModule>
                    <MultiChoiceModal2
                      options={formdata[num - 1].options || []}
                      checked={
                        !!answer[formdata[num - 1].actionId || ""] &&
                        answer[formdata[num - 1].actionId || ""]
                      }
                      onChange={(e) =>
                        handleUpdate(
                          e,
                          formdata[num - 1].actionId || "",
                          "check"
                        )
                      }
                      modalType={onboardingGetPropsFunctions.getMultiChoice()}
                      // style={{
                      //     borderColor:
                      //         styleConfig?.MultiChoice?.style?.borderColor ||
                      //         themeConfig?.borderColor,
                      //     ...styleConfig?.MultiChoice?.style,
                      //     color:
                      //         styleConfig?.MultiChoice?.style?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.MultiChoice?.style,
                      // }}

                      style={themeManager.getMultiChoiceStyles()}
                      // selectedStyle={{
                      //     color:
                      //         styleConfig?.MultiChoice?.selectedStyle?.color ||
                      //         questThemeData?.accentColor ||
                      //         BrandTheme?.accentColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.MultiChoice?.selectedStyle,
                      // }}
                      selectedStyle={themeManager.getMultiChoiceSelectedStyles('modal2')}
                      key={formdata[num - 1]?.actionId}
                    />
                  </div>
                ) : (
                  <div className="label-input-cont" key={index}>
                    <LabelModule
                      htmlFor=""
                      // style={{
                      //     color:
                      //         styleConfig?.Label?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.Label,
                      // }}
                      style={themeManager.getLabelStyles()}
                    >
                      {`${formdata[num - 1]?.question || ""} ${
                        !!formdata[num - 1]?.required || false ? "*" : ""
                      }`}
                    </LabelModule>
                    <MultiChoiceModal1
                      options={formdata[num - 1].options || []}
                      checked={
                        !!answer[formdata[num - 1].actionId || ""] &&
                        answer[formdata[num - 1].actionId || ""]
                      }
                      onChange={(e) =>
                        handleUpdate(
                          e,
                          formdata[num - 1].actionId || "",
                          "check"
                        )
                      }
                      modalType={onboardingGetPropsFunctions.getMultiChoice()}
                      // style={{
                      //     borderColor:
                      //         styleConfig?.MultiChoice?.style?.borderColor ||
                      //         themeConfig?.borderColor,
                      //     ...styleConfig?.MultiChoice?.style,
                      //     color:
                      //         styleConfig?.MultiChoice?.style?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.MultiChoice?.style,
                      // }}
                      style={themeManager.getMultiChoiceStyles()}
                      // selectedStyle={{
                      //     color:
                      //         styleConfig?.MultiChoice?.selectedStyle?.color ||
                      //         questThemeData?.accentColor ||
                      //         BrandTheme?.accentColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.MultiChoice?.selectedStyle,
                      // }}
                      selectedStyle={themeManager.getMultiChoiceSelectedStyles('modal1')}
                      key={formdata[num - 1]?.actionId}
                    />
                  </div>
                )
              ) : null
            )
          : formdata?.map((data, index) =>
              data.type == "USER_INPUT_TEXT" ? (
                <div className="label-input-cont">
                  <LabelModule
                    htmlFor=""
                    // style={{
                    //     color:
                    //         styleConfig?.Label?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Label,
                    // }}

                    style={themeManager.getLabelStyles()}
                  >
                    {`${data?.question || ""} ${
                      !!data?.required || false ? "*" : ""
                    }`}
                  </LabelModule>
                  <TextInputModule
                    placeholder={data?.placeholder || data?.question || ""}
                    value={answer[data?.actionId || ""]}
                    // iconColor={
                    //   styleConfig?.Input?.color ||
                    //   BrandTheme?.primaryColor ||
                    //   themeConfig?.primaryColor ||
                    //   "#B9B9B9"
                    // }

                    regexKey={data?.regexKey}
                    regexMessage={data?.regexMessage}
                    validateInputRegex={(validation) =>
                      validateInputRegex(validation, data.actionId)
                    }
                    // errorText={
                    //     styleConfig?.TextError?.text == undefined
                    //         ? "Invalid text format"
                    //         : styleConfig?.TextError?.text
                    // }
                    errorText={themeManager.getTextInputErrorText()}
                    // textErrorStyle={styleConfig?.TextError?.errorStyle}
                    textErrorStyle={themeManager.getTextInputErrorStyles()}
                    onChange={(e) => handleUpdate(e, data.actionId || "", "")}
                    // style={{
                    //     borderColor:
                    //         styleConfig?.Input?.borderColor || themeConfig?.borderColor,
                    //     color:
                    //         styleConfig?.Input?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Input,
                    // }}
                    style={themeManager.getTextInputStyles()}
                    name={`input-${designState?.[currentPage]?.[index]}`}
                    key={data?.actionId}
                  />
                </div>
              ) : data.type == "USER_INPUT_EMAIL" ? (
                <div className="label-input-cont">
                  <LabelModule
                    htmlFor=""
                    // style={{
                    //     color:
                    //         styleConfig?.Label?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Label,
                    // }}
                    style={themeManager.getLabelStyles()}
                  >
                    {`${data?.question || ""} ${
                      !!data?.required || false ? "*" : ""
                    }`}
                  </LabelModule>
                  <EmailInputModule
                    placeholder={data?.placeholder || data?.question || ""}
                    value={answer[data?.actionId || ""]}
                    // iconColor={
                    //     styleConfig?.Input?.color ||
                    //     BrandTheme?.primaryColor ||
                    //     themeConfig?.primaryColor ||
                    //     "#B9B9B9"
                    // }
                    iconColor={themeManager.getEmailIconColor()}
                    validateInputRegex={(validation) =>
                      validateInputRegex(validation, data.actionId)
                    }
                    regexKey={data?.regexKey}
                    regexMessage={data?.regexMessage}
                    onChange={(e) => handleUpdate(e, data.actionId || "", "")}
                    // style={{
                    //     borderColor:
                    //         styleConfig?.Input?.borderColor || themeConfig?.borderColor,
                    //     color:
                    //         styleConfig?.Input?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Input,
                    // }}
                    style={themeManager.getTextInputStyles()}
                    // emailtext={
                    //     styleConfig?.EmailError?.text == undefined
                    //         ? "Invalid email format"
                    //         : styleConfig?.EmailError?.text
                    // }
                    emailtext={themeManager.getEmailInputErrorText()}
                    // emailErrorStyle={styleConfig?.EmailError?.errorStyle}
                    emailErrorStyle={themeManager.getEMailInputErrorStyles()}
                    name={`input-${designState?.[currentPage]?.[index]}`}
                    key={data?.actionId}
                  />
                </div>
              ) : data.type == "USER_INPUT_PHONE" ||
                data.type == "USER_INPUT_NUMBER" ? (
                <div className="label-input-cont">
                  <LabelModule
                    htmlFor=""
                    // style={{
                    //     color:
                    //         styleConfig?.Label?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Label,
                    // }}
                    style={themeManager.getLabelStyles()}
                  >
                    {`${data?.question || ""} ${
                      !!data?.required || false ? "*" : ""
                    }`}
                  </LabelModule>
                  <NumberInputModule
                    placeholder={data?.placeholder || data?.question || ""}
                    value={answer[data.actionId || ""]}
                    // iconColor={
                    //     styleConfig?.Input?.color ||
                    //     BrandTheme?.primaryColor ||
                    //     themeConfig?.primaryColor ||
                    //     "#B9B9B9"
                    // }
                    iconColor={themeManager.getEmailIconColor()}
                    validateInputRegex={(validation) =>
                      validateInputRegex(validation, data.actionId)
                    }
                    regexKey={data?.regexKey}
                    regexMessage={data?.regexMessage}
                    onChange={(e) => handleUpdate(e, data.actionId || "", "")}
                    // style={{
                    //     borderColor:
                    //         styleConfig?.Input?.borderColor || themeConfig?.borderColor,
                    //     color:
                    //         styleConfig?.Input?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Input,
                    // }}
                    style={themeManager.getTextInputStyles()}
                    // numbertext={
                    //     styleConfig?.NumberError?.text == undefined
                    //         ? "Invalid number format"
                    //         : styleConfig?.NumberError?.text
                    // }
                    numbertext={themeManager.getNumberInputErrorText()}
                    // numberErrorStyle={styleConfig?.NumberError?.errorStyle}
                    numberErrorStyle={themeManager.getNumberInputErrorStyles()}
                    name={`input-${designState?.[currentPage]?.[index]}`}
                    key={data?.actionId}
                  />
                </div>
              ) : data.type == "USER_INPUT_TEXTAREA" ? (
                <div className="label-input-cont">
                  <LabelModule
                    htmlFor=""
                    // style={{
                    //     color:
                    //         styleConfig?.Label?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Label,
                    // }}
                    style={themeManager.getLabelStyles()}
                  >
                    {`${data?.question || ""} ${
                      data?.placeholder || data?.question || ""
                    }`}
                  </LabelModule>
                  <TextAreaModule
                    value={answer[data.actionId || ""]}
                    onChange={(e) => handleUpdate(e, data.actionId || "", "")}
                    // style={{
                    //     borderColor:
                    //         styleConfig?.TextArea?.borderColor || themeConfig?.borderColor,
                    //     color:
                    //         styleConfig?.TextArea?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.TextArea,
                    // }}
                    style={themeManager.getTextAreaInputStyles()}
                    textareatext={themeManager.getTextAreaInputErrorText()}
                    textareaErrorStyle={themeManager.getTextAreaInputErrorStyles()}
                    validateInputRegex={(validation) =>
                      validateInputRegex(validation, data.actionId)
                    }
                    placeholder={data?.placeholder || data?.question || ""}
                    key={data?.actionId}
                  />
                </div>
              ) : data.type == "USER_INPUT_DATE" ? (
                <div className="label-input-cont">
                  <LabelModule
                    htmlFor=""
                    // style={{
                    //     color:
                    //         styleConfig?.Label?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Label,
                    // }}

                    style={themeManager.getLabelStyles()}
                  >
                    {`${data?.question || ""} ${
                      !!data?.required || false ? "*" : ""
                    }`}
                  </LabelModule>
                  <DateInputModule
                    type={"date"}
                    placeholder={data?.placeholder || data?.question || ""}
                    value={answer[data.actionId || ""]}
                    onChange={(e) => handleUpdate(e, data.actionId || "", "")}
                    iconColor={themeManager.getEmailIconColor()}
                    // style={{
                    //     borderColor:
                    //         styleConfig?.Input?.borderColor || themeConfig?.borderColor,
                    //     color:
                    //         styleConfig?.Input?.color ||
                    //         BrandTheme?.primaryColor ||
                    //         themeConfig?.primaryColor,
                    //     ...styleConfig?.Input,
                    // }}
                    style={themeManager.getTextInputStyles()}
                    key={data?.actionId}
                    preventFutureSelection={true}
                    preventPastSelection={true}
                    minDate=""
                    maxDate=""
                  />
                </div>
              ) : data.type == "USER_INPUT_SINGLE_CHOICE" ? (
                !!onboardingGetPropsFunctions.getSingleChoose() &&
                (onboardingGetPropsFunctions.getSingleChoose() === "modal1" ||
                  onboardingGetPropsFunctions.getSingleChoose() ===
                    "modal2") ? (
                  // for modal 1 or 2
                  <div className="label-input-cont">
                    <LabelModule
                      htmlFor=""
                      // style={{
                      //     color:
                      //         styleConfig?.Label?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.Label,
                      // }}
                      style={themeManager.getLabelStyles()}
                    >
                      {`${data?.question || ""} ${
                        !!data?.required || false ? "*" : ""
                      }`}
                    </LabelModule>
                    <SingleChoiceModal1
                      options={data.options || []}
                      type={onboardingGetPropsFunctions.getSingleChoose()}
                      onChange={(e) =>
                        handleUpdate(e, data.actionId || "", "radio")
                      }
                      checked={answer[data.actionId || ""]}
                      // style={{
                      //     borderColor:
                      //         styleConfig?.SingleChoice?.style?.borderColor ||
                      //         themeConfig?.borderColor,
                      //     color:
                      //         styleConfig?.SingleChoice?.style?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.secondaryColor,
                      //     ...styleConfig?.SingleChoice?.style,
                      // }}
                      style={themeManager.getSingleChoiceStyles()}
                      // hoverBackground={styleConfig?.SingleChoice?.hoverBackground}
                      hoverBackground={themeManager.getSingleChoiceHoverBackground()}
                      // selectedStyle={{
                      //     accentColor:
                      //         styleConfig?.SingleChoice?.selectedStyle?.accentColor ||
                      //         questThemeData?.accentColor ||
                      //         BrandTheme?.accentColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.SingleChoice?.selectedStyle,
                      // }}
                      selectedStyle={themeManager.getSingleChoiceSelectedStyles()}
                      key={data?.actionId}
                    />
                    {data?.manualInput != false &&
                      answer[data.actionId || ""] == data?.manualInput && (
                        <TextInputModule
                          type={"text"}
                          onChange={(e) =>
                            handleUpdate(e, data.actionId || "" + "/manual", "")
                          }
                          value={answer[data.actionId || "" + "/manual"]}
                          placeholder="Please fill manually"
                          // style={{
                          //     borderColor:
                          //         styleConfig?.Input?.borderColor || themeConfig?.borderColor,
                          //     color:
                          //         styleConfig?.Input?.color ||
                          //         BrandTheme?.primaryColor ||
                          //         themeConfig?.primaryColor,
                          //     ...styleConfig?.Input,
                          // }}
                          style={themeManager.getTextInputStyles()}
                          key={data?.actionId}
                        />
                      )}
                  </div>
                ) : (
                  <div className="label-input-cont">
                    <LabelModule
                      htmlFor=""
                      // style={{
                      //     color:
                      //         styleConfig?.Label?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.Label,
                      // }}
                      style={themeManager.getLabelStyles()}
                    >
                      {`${data?.question || ""} ${
                        !!data?.required || false ? "*" : ""
                      }`}
                    </LabelModule>
                    <SingleChoiceModal3
                      options={data.options || []}
                      type={onboardingGetPropsFunctions.getSingleChoose()}
                      onChange={(e) =>
                        handleUpdate({ target: e }, data.actionId || "", "")
                      }
                      checked={answer[data.actionId || ""]}
                      // style={{
                      //     borderColor:
                      //         styleConfig?.SingleChoice?.style?.borderColor ||
                      //         themeConfig?.borderColor,
                      //     color:
                      //         styleConfig?.SingleChoice?.style?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.secondaryColor,
                      //     ...styleConfig?.SingleChoice?.style,
                      // }}
                      style={themeManager.getSingleChoiceStyles()}
                      // hoverBackground={styleConfig?.SingleChoice?.hoverBackground}
                      hoverBackground={themeManager.getSingleChoiceHoverBackground()}
                      // selectedStyle={{
                      //     accentColor:
                      //         styleConfig?.SingleChoice?.selectedStyle?.accentColor ||
                      //         questThemeData?.accentColor ||
                      //         BrandTheme?.accentColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.SingleChoice?.selectedStyle,
                      // }}
                      selectedStyle={themeManager.getSingleChoiceSelectedStyles()}
                      key={data?.actionId}
                    />
                    {data?.manualInput != false &&
                      answer[data.actionId || ""] == data?.manualInput && (
                        <TextInputModule
                          type={"text"}
                          onChange={(e) =>
                            handleUpdate(e, data.actionId || "" + "/manual", "")
                          }
                          value={answer[data.actionId || "" + "/manual"]}
                          placeholder="Please fill manually"
                          // style={{
                          //     borderColor:
                          //         styleConfig?.Input?.borderColor || themeConfig?.borderColor,
                          //     color:
                          //         styleConfig?.Input?.color ||
                          //         BrandTheme?.primaryColor ||
                          //         themeConfig?.primaryColor,
                          //     ...styleConfig?.Input,
                          // }}
                          style={themeManager.getTextInputStyles()}
                          key={data?.actionId}
                        />
                      )}
                  </div>
                )
              ) : data.type == "USER_INPUT_MULTI_CHOICE" ? (
                !!onboardingGetPropsFunctions.getMultiChoice() &&
                onboardingGetPropsFunctions.getMultiChoice() == "modal2" ? (
                  <div className="label-input-cont">
                    <LabelModule
                      htmlFor=""
                      // style={{
                      //     color:
                      //         styleConfig?.Label?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.Label,
                      // }}

                      style={themeManager.getLabelStyles()}
                    >
                      {`${data?.question || ""} ${
                        !!data?.required || false ? "*" : ""
                      }`}
                    </LabelModule>
                    <MultiChoiceModal2
                      options={data.options || []}
                      checked={
                        !!answer[data.actionId || ""] &&
                        answer[data.actionId || ""]
                      }
                      onChange={(e) =>
                        handleUpdate(e, data.actionId || "", "check")
                      }
                      modalType={onboardingGetPropsFunctions.getMultiChoice()}
                      // style={{
                      //     borderColor:
                      //         styleConfig?.MultiChoice?.style?.borderColor ||
                      //         themeConfig?.borderColor,
                      //     ...styleConfig?.MultiChoice?.style,
                      //     color:
                      //         styleConfig?.MultiChoice?.style?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.MultiChoice?.style,
                      // }}
                      style={themeManager.getMultiChoiceStyles()}
                      // selectedStyle={{
                      //     color:
                      //         styleConfig?.MultiChoice?.selectedStyle?.color ||
                      //         questThemeData?.accentColor ||
                      //         BrandTheme?.accentColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.MultiChoice?.selectedStyle,
                      // }}
                      selectedStyle={themeManager.getMultiChoiceSelectedStyles('modal2')}
                      key={data?.actionId}
                    />
                  </div>
                ) : (
                  <div className="label-input-cont">
                    <LabelModule
                      htmlFor=""
                      // style={{
                      //     color:
                      //         styleConfig?.Label?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.Label,
                      // }}
                      style={themeManager.getLabelStyles()}
                    >
                      {`${data?.question || ""} ${
                        !!data?.required || false ? "*" : ""
                      }`}
                    </LabelModule>
                    <MultiChoiceModal1
                      options={data.options || []}
                      checked={
                        !!answer[data.actionId || ""] &&
                        answer[data.actionId || ""]
                      }
                      onChange={(e) =>
                        handleUpdate(e, data.actionId || "", "check")
                      }
                      modalType={onboardingGetPropsFunctions.getMultiChoice()}
                      // style={{
                      //     borderColor:
                      //         styleConfig?.MultiChoice?.style?.borderColor ||
                      //         themeConfig?.borderColor,
                      //     ...styleConfig?.MultiChoice?.style,
                      //     color:
                      //         styleConfig?.MultiChoice?.style?.color ||
                      //         BrandTheme?.primaryColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.MultiChoice?.style,
                      // }}
                      style={themeManager.getMultiChoiceStyles()}
                      // selectedStyle={{
                      //     color:
                      //         styleConfig?.MultiChoice?.selectedStyle?.color ||
                      //         questThemeData?.accentColor ||
                      //         BrandTheme?.accentColor ||
                      //         themeConfig?.primaryColor,
                      //     ...styleConfig?.MultiChoice?.selectedStyle,
                      // }}
                      selectedStyle={themeManager.getMultiChoiceSelectedStyles('modal1')}
                      key={data?.actionId}
                    />
                  </div>
                )
              ) : null
            )}

        {formdata &&
          formdata.length > 0 &&
          (!!designState && designState.length > 1 ? (
            controlBtnType == "Buttons" ||
            uiProps?.controlBtnType === "Buttons" ? (
              <div className="q-onb-main-criteria">
                {currentPage > 0 && (
                  <SecondaryButton
                    style={{
                      opacity: currentPage == 0 ? "0" : "1",
                      cursor: currentPage == 0 ? "context-menu" : "pointer",

                      // borderColor:
                      //     styleConfig?.SecondaryButton?.borderColor ||
                      //     themeConfig?.borderColor,
                      // background:
                      //     styleConfig?.SecondaryButton?.backgroundColor || BrandTheme?.secondaryButton ||
                      //     themeConfig?.backgroundColor,
                      // color:
                      //     styleConfig?.SecondaryButton?.color ||
                      //     themeConfig?.primaryColor,
                      // ...styleConfig?.SecondaryButton,

                      borderColor:
                        themeManager.getSecondaryButtonStyles().borderColor,
                      background:
                        themeManager.getSecondaryButtonStyles().background,
                      color: themeManager.getSecondaryButtonStyles().color,
                      ...themeManager.getSecondaryButtonStyles(),
                    }}
                    className="q-onb-main-btn"
                    onClick={() => {
                      GeneralFunctions.fireTrackingEvent(
                        "quest_onboarding_secondary_btn_clicked",
                        "onboarding"
                      );
                      currentPage > 0 &&
                        setCurrentPage &&
                        setCurrentPage(currentPage - 1);
                    }}
                  >
                    Previous
                  </SecondaryButton>
                )}

                <PrimaryButton
                  onClick={() => {
                    GeneralFunctions.fireTrackingEvent(
                      "quest_onboarding_primary_btn_clicked",
                      "onboarding"
                    );
                    // general.trackEvent("quest-onboarding-primary-btn-click",
                    //   (userId || uniqueUserId || user.userId)!,
                    //   {
                    //     type: currentPage == designState.length - 1
                    //       ? nextBtnText
                    //         ? nextBtnText
                    //         : "Submit"
                    //       : "Continue"
                    //   },
                    //   true
                    // );
                    // currentPage != designState.length - 1
                    //   ? setCurrentPage(currentPage + 1)
                    //   : returnAnswers();

                    // if (validateForm()) {
                    if (checkValidationValues && checkValidationValues()) {
                      GeneralFunctions.fireTrackingEvent(
                        "quest_onboarding_primary_btn_clicked",
                        "onboarding"
                      );
                      currentPage !== designState.length - 1
                        ? setCurrentPage && setCurrentPage(currentPage + 1)
                        : returnAnswers && returnAnswers();
                    }
                  }}
                  type="submit"
                  disabled={
                    !btnFlag ||
                    !(checkValidationValues && checkValidationValues())
                  }
                  className="q-onb-main-btn2"
                  style={{
                    // background:
                    //     styleConfig?.PrimaryButton?.background ||
                    //     questThemeData?.buttonColor ||
                    //     BrandTheme?.primaryButton ||
                    //     themeConfig?.buttonColor,
                    // ...styleConfig?.PrimaryButton,
                    background:
                      themeManager.getPrimaryButtonStyles().background,
                    ...themeManager.getPrimaryButtonStyles(),
                  }}
                >
                  {currentPage == designState.length - 1
                    ? nextBtnText
                      ? nextBtnText
                      : "Submit"
                    : "Continue"}
                </PrimaryButton>
              </div>
            ) : (
              <div className="q-onb-main-arrow-div">
                <SecondaryButton
                  className="q-onb-main-arrow"
                  onClick={() => {
                    GeneralFunctions.fireTrackingEvent(
                      "quest_onboarding_secondary_btn_clicked",
                      "onboarding"
                    );

                    currentPage > 0 &&
                      setCurrentPage &&
                      setCurrentPage(currentPage - 1);
                  }}
                  style={{
                    opacity: currentPage == 0 ? "0" : "1",
                    cursor: currentPage == 0 ? "context-menu" : "pointer",
                    height: themeManager.getSecondaryButtonAeroStyles().height,
                    width: themeManager.getSecondaryButtonAeroStyles().width,
                    borderRadius:
                      themeManager.getSecondaryButtonAeroStyles().borderRadius,
                    padding:
                      themeManager.getSecondaryButtonAeroStyles().padding,
                    border:
                      themeManager.getSecondaryButtonAeroStyles().border ||
                      "1.5px solid #afafaf",
                    borderColor:
                      themeManager.getSecondaryButtonAeroStyles().borderColor,
                    backgroundColor:
                      themeManager.getSecondaryButtonAeroStyles()
                        .backgroundColor,
                    color: themeManager.getSecondaryButtonAeroStyles().color,
                    ...themeManager.getSecondaryButtonAeroStyles(),
                  }}
                >
                  {leftArrow()}
                </SecondaryButton>
                <PrimaryButton
                  className="q-onb-main-arrow2"
                  onClick={() => {
                    GeneralFunctions.fireTrackingEvent(
                      "quest_onboarding_primary_btn_clicked",
                      "onboarding"
                    );
                    // currentPage != designState.length - 1
                    //   ? setCurrentPage(currentPage + 1)
                    //   : returnAnswers();
                    // if (validateForm()) {
                    if (checkValidationValues && checkValidationValues()) {
                      GeneralFunctions.fireTrackingEvent(
                        "quest_onboarding_primary_btn_clicked",
                        "onboarding"
                      );
                      currentPage !== designState.length - 1
                        ? setCurrentPage && setCurrentPage(currentPage + 1)
                        : returnAnswers && returnAnswers();
                    }
                  }}
                  type="submit"
                  // disabled={(!btnFlag || !validateForm())}
                  disabled={
                    !btnFlag ||
                    !(checkValidationValues && checkValidationValues())
                  }
                  style={{
                    // height: styleConfig?.PrimaryButton?.height || "44px",
                    // width: styleConfig?.PrimaryButton?.width || "44px",
                    // borderRadius:
                    //     styleConfig?.PrimaryButton?.borderRadius || "50%",
                    // padding: styleConfig?.PrimaryButton?.padding || "10px",
                    // border:
                    //     styleConfig?.PrimaryButton?.border ||
                    //     "1.5px solid #D1ACFF",
                    // background:
                    //     styleConfig?.PrimaryButton?.background ||
                    //     questThemeData?.buttonColor ||
                    //     BrandTheme?.primaryButton ||
                    //     themeConfig?.buttonColor,
                    // ...styleConfig?.PrimaryButton,

                    height: themeManager.getPrimaryButtonAeroStyles().height,
                    width: themeManager.getPrimaryButtonAeroStyles().width,
                    borderRadius:
                      themeManager.getPrimaryButtonAeroStyles().borderRadius,
                    padding: themeManager.getPrimaryButtonAeroStyles().padding,
                    border:
                      themeManager.getPrimaryButtonAeroStyles().border ||
                      "1.5px solid #D1ACFF",
                    borderColor:
                      themeManager.getSecondaryButtonAeroStyles().borderColor,
                    background:
                      themeManager.getPrimaryButtonAeroStyles().background,
                    ...themeManager.getPrimaryButtonAeroStyles(),
                  }}
                >
                  {rightArrow()}
                </PrimaryButton>
              </div>
            )
          ) : (
            <div>
              <PrimaryButton
                className="q-onb-main-btn3"
                onClick={() => {
                  GeneralFunctions.fireTrackingEvent(
                    "quest_onboarding_single_page_submit_button_clicked",
                    "onboarding"
                  );
                  // if (validateForm()) {
                  if (checkValidationValues && checkValidationValues()) {
                    GeneralFunctions.fireTrackingEvent(
                      "quest_onboarding_primary_btn_clicked",
                      "onboarding"
                    );
                    currentPage !== designState.length - 1
                      ? setCurrentPage && setCurrentPage(currentPage + 1)
                      : returnAnswers && returnAnswers();
                  }
                }}
                type="submit"
                // disabled={(!btnFlag || !validateForm())}
                disabled={
                  !btnFlag ||
                  !(checkValidationValues && checkValidationValues())
                }
                style={{
                  // border:
                  //     styleConfig?.SecondaryButton?.border ||
                  //     "1.5px solid #afafaf",
                  // background:
                  //     styleConfig?.PrimaryButton?.background ||
                  //     questThemeData?.buttonColor ||
                  //     BrandTheme?.primaryButton ||
                  //     themeConfig?.buttonColor,
                  // ...styleConfig?.PrimaryButton,

                  border: themeManager.getNormalButtonStyles().border,
                  background: themeManager.getNormalButtonStyles().background,
                  ...themeManager.getNormalButtonStyles(),
                }}
              >
                {nextBtnText ? nextBtnText : "Continue"}
              </PrimaryButton>
            </div>
          ))}
      </div>
    </>
  );
};

export default Content;
